export default "__VITE_ASSET__CjTDEFCj__"